// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modal{width:460px !important;padding-bottom:0;background-color:#fff}.modal__header{box-shadow:none}.modal__body{padding-top:5px}.modal__footer{background:#fff;padding:20px 0px;border-radius:6px}.modal__icon{color:#657fb5}.modal__content{color:#04263d}.modal .bp3-button-text{min-width:75px;line-height:20px;text-align:center}.modal .bp3-dialog-body{margin:0px;padding:20px;padding-top:0px}\n", ""]);
// Exports
module.exports = exports;
